import APIBase from "./APIBase.ts";
import {SessionRequest} from "../sdo/SessionRequest.ts";
import {SessionNetwork} from "../sdo/SessionNetwork.ts";

export default class SessionAPI extends APIBase
{
    constructor()
    {
        super();
    }

    async start<T = unknown>(username: string, password: string)
    {
        const request:SessionRequest = {
            type: "WEB",
            identifier: username,
            password: password,
            timeout: (1000 * 60 * 60 * 8)
        };

        const serviceURL = this.buildURL(true, `session/WEB`);
        return this.post<T>(serviceURL, request, false);
    }

    async end<T = unknown>()
    {
        const serviceURL = this.buildURL(true, `session/WEB/end`);
        return this.post<T>(serviceURL, {});
    }

    async getNetworks<T = unknown>()
    {
        const serviceURL = this.buildURL(true, `session/WEB/networks`);
        return this.get<T>(serviceURL);
    }

    async connectToNetwork<T = unknown>(network:SessionNetwork)
    {
        const jsonPayload = JSON.stringify(network);

        const serviceURL = this.buildURL(true, `session/WEB/networks/connect`);
        return this.post<T>(serviceURL, jsonPayload);
    }
}